import {Inject, Injectable} from '@angular/core';
import {APP_BASE_HREF} from '@angular/common';

@Injectable()
export class StorageHandler {

  private href = '';

  constructor(@Inject(APP_BASE_HREF) public baseHref: string) {
    const re = new RegExp('/', 'g');
    // this.href = baseHref.replace(re, '');
  }

  public setLocalStorage(name, value) {
    name = this.href + ':' + name;
    localStorage.setItem(name, value);
  }

  public getLocalStorage(name) {
    name = this.href + ':' + name;
    return localStorage.getItem(name);
  }

  public removeLocalStorage(name) {
    name = this.href + ':' + name;
    localStorage.removeItem(name);
  }

  public setSessionStorageItem(name: string, value: any) {
    name = this.href + ':' + name;
    sessionStorage.setItem(name, value);
  }

  public deleteSessionStorageItem(name: string) {
    name = this.href + ':' + name;
    sessionStorage.removeItem(name);
  }

  public getSessionStorageItem(name: string): any {
    name = this.href + ':' + name;
    return sessionStorage.getItem(name);
  }

  public clearStorages(): void {
    sessionStorage.clear();
    localStorage.clear();
  }

}
